import React from "react"

import { FormControl, FormHelperText, FormLabel, Select, Option } from "@mui/joy";
import { Controller } from "react-hook-form";
import { Icon } from '../../assets';

const InputSelect = (props) => {
    const { editing, required, name, control, label, autoFocus, placeholder, type = "select", hint, icon, haserror, options, className = "" } = props
    let { disabled, readonly } = props;
    if (!editing) readonly = true;
    if (readonly) disabled = true;

    let generalClass = "form-element-control";
    generalClass += (editing) ? " editing" : " reading";
    generalClass += (haserror) ? " error" : "";
    generalClass += (required) ? " required" : "";
    generalClass += (disabled) ? " disabled" : "";
    generalClass += (readonly) ? " readonly" : "";


    const generateOptions = () => {
        return options.map((option, k) => (
            <Option key={k} value={option.value}>{option.label}</Option>
        ));
    };

    return (

        <Controller
            name={name}
            control={control}
            render={({
                field: { onChange, value, name },
                fieldState: { error, invalid },
                formState,
            }) => (
                <div className={("form-element select "+className).trim()}>
                    <FormControl error={invalid} className={(error) ? generalClass + " form-element-error" : generalClass}>
                        <FormLabel className="form-element-label" htmlFor={name}>{label}</FormLabel>
                        <Select
                            id={name}
                            type={type}
                            name={name}
                            value={value}
                            error={invalid}
                            onChange={(e, v) => { onChange(v); } }
                            variant="outlined"
                            autoComplete="off"
                            className="form-element-field form-element-field-select"

                            autoFocus={autoFocus}
                            placeholder={placeholder}
                            disabled={disabled}
                            readOnly={readonly}
                            required={required}

                            startDecorator={(icon) ? (
                                <Icon icon={icon} />
                            ) : (
                                <></>
                            )}
                            endDecorator={(haserror || error) ? (
                                <Icon icon="faCircleExclamation" />
                            ) : (
                                <></>
                            )}
                        >
                            {generateOptions()}
                        </Select>
                        <FormHelperText className="form-element-hint">
                            {(haserror || error) ? (
                                <>
                                    {error ? error.message : 'Messaggio di errore'}
                                </>
                            ) : (
                                <>
                                    {hint}
                                </>
                            )}
                        </FormHelperText>
                    </FormControl>
                </div>
            )}
        />

    );
};


export default InputSelect;
